import {
  DefaultLayout,
  EmptyLayout,
  HeaderLayout,
} from '@customer/components/layouts';
import { faTruckMonster } from '@fortawesome/free-solid-svg-icons';

export const publicRoute = [
  {
    path: '/Intro',
    name: 'Home.Intro',
    component: () => import('@/front/customer/views/home/Intro.vue'),
  },
  {
    path: '/maintenance',
    component: () =>
      import('@common/components/maintenance/SystemMaintenace.vue'),
  },
  {
    // 사용자 계정 삭제 안내 ( 앱에 링크 )
    path: '/UserDeleteGuide',
    component: () =>
      import('@/front/customer/components/common/UserDeleteGuide.vue'),
  },
  {
    path: '/ProfileRegionPublic',
    name: 'Auth.ProfileRegionPublic',
    meta: {},
    component: () =>
      import('@/front/customer/views/auth/ProfileRegionPublic.vue'),
  },
  {
    path: '/Auth',
    component: DefaultLayout,
    redirect: '/Auth/Login',
    hidden: true,
    meta: {
      preventAuth: true,
    },
    children: [
      {
        path: 'Login',
        name: 'Auth.Login',
        meta: {},
        component: () => import('@/front/customer/views/auth/Login.vue'),
      },
      {
        path: 'JoinMobile',
        name: 'Auth.JoinMobile',
        meta: {
          header: {
            left: true,
          },
        },
        component: () => import('@/front/customer/views/auth/JoinMobile.vue'),
      },
      {
        path: 'JoinMobileAuth',
        name: 'Auth.JoinMobileAuth',
        meta: {
          header: {
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/auth/JoinMobileAuth.vue'),
      },
      {
        path: 'JoinGender',
        name: 'Auth.JoinGender',
        meta: {
          header: {
            left: true,
          },
        },
        component: () => import('@/front/customer/views/auth/JoinGender.vue'),
      },
      {
        path: 'JoinAge',
        name: 'Auth.JoinAge',
        meta: {
          header: {
            left: true,
          },
        },
        component: () => import('@/front/customer/views/auth/JoinAge.vue'),
      },
      {
        path: 'JoinRegion',
        name: 'Auth.JoinRegion',
        meta: {
          header: {
            left: true,
          },
        },
        component: () => import('@/front/customer/views/auth/JoinRegion.vue'),
      },
      {
        path: 'JoinNickname',
        name: 'Auth.JoinNickname',
        meta: {
          header: {
            left: true,
          },
        },
        component: () => import('@/front/customer/views/auth/JoinNickname.vue'),
      },
      {
        path: 'EmailConfirm',
        name: 'Auth.EmailConfirm',
        meta: {
          header: {
            title: '이메일 인증',
            left: true,
          },
        },
        component: () => import('@/front/customer/views/auth/EmailConfirm.vue'),
      },
      {
        path: 'PhoneNumberChange',
        name: 'Auth.PhoneNumberChange',
        meta: {
          header: {
            title: '휴대폰 번호 변경',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/auth/PhoneNumberChange.vue'),
        props: route => ({
          email: route.params.email,
          authNumber: route.params.authNumber,
        }),
      },
    ],
  },
  {
    path: '/Agreement',
    component: DefaultLayout,
    redirect: '/Agreement/Terms',
    hidden: true,
    meta: {},
    children: [
      {
        path: 'Terms/:type',
        name: 'Agreement.Terms',
        meta: {},
        component: () =>
          import('@/front/customer/components/common/Agreements.vue'),
        props: route => ({
          type: route.params.type,
          header: route.params.title,
        }),
      },
    ],
  },
  {
    path: '/Download',
    component: EmptyLayout,
    redirect: '/Download/App',
    hidden: true,
    meta: {},
    children: [
      {
        path: 'App',
        name: 'Download.App',
        meta: {},
        component: () =>
          import('@/front/customer/components/common/AppDownload.vue'),
      },
    ],
  },
  {
    path: '/DealList',
    component: HeaderLayout,
    redirect: '/Mobile/DealList',
    hidden: true,
    // meta: {
    //   preventAuth: true,
    // },
    // meta: {
    //   requiresAuth: true,
    // },
    children: [
      {
        path: '/Mobile/DealList',
        name: 'Mobile.DealList',
        meta: {
          header: {
            title: ' ',
            leftMain: true,
            bgGr: true,
          },
        },
        component: () => import('@/front/customer/views/mobile/DealList.vue'),
      },
      {
        path: '/Mobile/DealDetail',
        name: 'Mobile.DealDetail',
        meta: {
          header: {
            title: '상품 상세',
            left: true,
          },
        },
        component: () => import('@/front/customer/views/mobile/DealDetail.vue'),
      },
      {
        path: '/Mobile/DeviceInfo',
        name: 'Mobile.DeviceInfo',
        meta: {
          header: {
            title: '휴대폰 스팩 보기',
            left: true,
          },
        },
        component: () => import('@/front/customer/views/mobile/DeviceInfo.vue'),
      },
    ],
  },
];

export const protectedRoute = [
  {
    path: '/auth',
    component: DefaultLayout,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'Profile',
        name: 'Auth.Profile',
        meta: {},
        component: () =>
          import('@/front/customer/views/auth/ProfileSetting.vue'),
      },
      {
        path: 'ProfileComplete',
        name: 'Auth.ProfileComplete',
        meta: {},
        component: () =>
          import('@/front/customer/views/auth/ProfileComplete.vue'),
      },
      {
        path: 'Region',
        name: 'Auth.Region',
        meta: {
          header: {
            title: '우리동네 설정',
            left: true,
          },
        },
        component: () => import('@/front/customer/views/auth/Region.vue'),
      },
      {
        path: 'RegionSelected',
        name: 'Auth.RegionSelected',
        meta: {
          header: {
            title: '우리동네 설정',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/auth/RegionSelected.vue'),
      },
      {
        path: 'ProfileRegion',
        name: 'Auth.ProfileRegion',
        meta: {},
        component: () =>
          import('@/front/customer/views/auth/ProfileRegion.vue'),
      },
    ],
  },
  {
    path: '/',
    component: DefaultLayout,
    redirect: '/home',
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'home',
        name: 'Home',
        meta: {
          header: {
            logo: true,
            searchBtn: true,
            myBtn: true,
            titleLeft: true,
            bgGr: true,
          },
          footer: true,
          footerMain: 'main',
          requiresAuth: true,
        },
        component: () => import('@/front/customer/views/home/Index.vue'),
      },
      // {
      //   path: 'main',
      //   name: 'Main',
      //   meta: {
      //     footer: true,
      //     footerMain: 'main',
      //     requiresAuth: true,
      //   },
      //   component: () => import('@/front/customer/views/home/Main.vue'),
      // },
      // {
      //   path: '/Estimate/Manage',
      //   name: 'Estimation.Manage',
      //   meta: {
      //     header: {
      //       title: '견적 요청서 관리',
      //       left: true,
      //     },
      //   },
      //   component: () =>
      //     import('@/front/customer/views/estimation/EstimationManage.vue'),
      // },
      {
        path: '/Estimate/Manage',
        name: 'Estimation.Manage',
        component: () =>
          import('@/front/customer/views/estimation/EstimationManage.vue'),
      },
      {
        path: '/Estimate/Create',
        name: 'Estimation.Create',
        meta: {
          header: {
            title: '견적 요청서 작성',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/estimation/EstimationCreate.vue'),
      },
      {
        path: '/Estimate/Form',
        name: 'Estimation.Form',
        meta: {
          header: {
            title: '견적 요청서 작성',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/estimation/EstimationForm.vue'),
      },
      {
        path: '/Estimate/Complete',
        name: 'Estimation.Complete',
        meta: {},
        component: () =>
          import('@/front/customer/views/estimation/EstimationComplete.vue'),
      },
      {
        path: '/Estimate/DeviceList',
        name: 'Estimation.DeviceList',
        meta: {
          header: {
            title: '모델 선택',
            left: true,
          },
        },
        component: () => import('@common/components/estimation/DeviceList.vue'),
      },
      // {
      //   path: '/Estimate/AutoCreate/:storeId',
      //   name: 'Estimation.AutoCreate',
      //   meta: {
      //     header: {
      //       title: '견적 요청서 작성',
      //       left: true,
      //     },
      //   },
      //   component: () =>
      //     import('@/front/customer/views/chat/EstimationAuto.vue'),
      //   props: route => ({
      //     storeId: route.params.storeId,
      //   }),
      // },
      // {
      //   path: '/Estimation/PreviewQuotation',
      //   name: 'Estimation.PreviewQuotation',
      //   meta: {
      //     header: {
      //       title: '미리보기',
      //       left: true,
      //     },
      //   },
      //   component: () =>
      //     import('@common/components/estimation/PreviewQuotation.vue'),
      // },
      {
        path: '/Booking/BookingForm',
        name: 'Booking.BookingForm',
        meta: {
          header: {
            title: route => route.query.title,
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/booking/BookingForm.vue'),
        props: route => ({
          telecomName: route.query.telecomName,
          mode: route.query.mode,
          id: route.query.id,
          // uuid: route.query.uuid,
        }),
      },
    ],
  },
  {
    path: '/MyPage',
    component: DefaultLayout,
    redirect: '/MyPage/Main',
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'Main',
        name: 'MyPage.Main',
        meta: {
          header: {
            title: '마이페이지',
            titleLeft: true,
            shareBtn: true,
          },
          footer: true,
          footerMain: 'mypage',
        },
        component: () => import('@/front/customer/views/mypage/Main.vue'),
      },
      {
        path: 'Profile',
        name: 'MyPage.Profile',
        meta: {
          header: {
            title: '프로필 관리',
            left: true,
          },
        },
        component: () => import('@/front/customer/views/mypage/Profile.vue'),
      },
      {
        path: 'Email',
        name: 'MyPage.Email',
        meta: {
          header: {
            title: '이메일 등록',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/mypage/EmailRegistration.vue'),
      },
      {
        path: 'Favorite',
        name: 'MyPage.Favorite',
        meta: {
          header: {
            title: '내 관심매장',
            left: true,
          },
        },
        component: () => import('@/front/customer/views/mypage/Favorite.vue'),
      },
      {
        path: 'InternetBookmarkPlan',
        name: 'MyPage.InternetBookmarkPlan',
        meta: {
          header: {
            title: '찜한 인터넷 요금제',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/mypage/InternetBookmarkPlan.vue'),
      },
      {
        path: 'MobileBookmarkPlan',
        name: 'MyPage.MobileBookmarkPlan',
        meta: {
          header: {
            title: '찜한 휴대폰',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/mypage/MobileBookmarkPlan.vue'),
      },
      {
        path: 'Notification',
        name: 'MyPage.Notification',
        meta: {
          header: {
            title: '알림 설정',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/mypage/Notification.vue'),
      },
      {
        path: 'Notice',
        name: 'MyPage.Notice',
        meta: {
          header: {
            title: '공지사항',
            left: true,
          },
        },
        component: () => import('@/front/customer/views/mypage/Board.vue'),
      },
      {
        path: 'Notice/:id',
        name: 'Notice.Article',
        meta: {
          header: {
            title: '공지사항',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/mypage/BoardDetail.vue'),
        props: route => ({
          id: route.params.id,
        }),
      },
      {
        path: 'FAQ',
        name: 'MyPage.FAQ',
        meta: {
          header: {
            title: '자주 묻는 질문',
            left: true,
          },
        },
        component: () => import('@/front/customer/views/mypage/Board.vue'),
      },
      {
        path: 'FAQ/:id',
        name: 'FAQ.Article',
        meta: {
          header: {
            title: '자주 묻는 질문',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/mypage/BoardDetail.vue'),
        props: route => ({
          id: route.params.id,
        }),
      },
      {
        path: 'SystemInquiry',
        name: 'MyPage.SystemInquiry',
        meta: {
          header: {
            title: '1:1 문의',
            left: true,
          },
        },
        component: () => import('@common/components/chat/SystemRoom.vue'),
      },
    ],
  },
  {
    path: '/keyword',
    component: DefaultLayout,
    redirect: '/keyword',
    hidden: true,
    meta: {
      requiresAuth: false,
    },
    children: [
      {
        //depth 1
        path: '/keyword',
        name: 'keyword',
        meta: {
          header: {
            title: '우리동네 매장에만 있는 혜택모음',
            left: true,
          },
        },
        component: () => import('@/front/customer/views/keyword/List.vue'),
      },
      {
        //depth 2
        path: '/benefit',
        name: 'keyword.benefit',
        meta: {
          header: {
            title: '우리동네 매장에만 있는 혜택모음',
            left: true,
          },
        },
        component: () => import('@/front/customer/views/keyword/Benefits.vue'),
      },
      {
        //depth 3
        path: '/shop',
        name: 'keyword.shop',
        meta: {
          header: {
            title: route => route.query.title,
            left: true,
          },
        },
        component: () => import('@/front/customer/views/keyword/Stores.vue'),
      },
    ],
  },
  {
    path: '/news',
    component: DefaultLayout,
    redirect: '/news',
    hidden: true,
    meta: {
      requiresAuth: false,
    },
    children: [
      {
        path: 'List',
        name: 'news',
        meta: {
          header: {
            title: ' ',
            left: true,
          },
        },
        component: () => import('@/front/customer/views/news/List.vue'),
        props: route => ({
          boardId: route.params.boardId,
          // header: route.params.title,
          header: route.query.title,
        }),
      },
      {
        path: 'List/:id',
        name: 'news.detail',
        meta: {
          header: {
            title: route => route.params.title,
            left: true,
          },
        },
        component: () => import('@/front/customer/views/news/detail/News.vue'),
        props: route => ({
          boardId: route.params.boardId,
        }),
      },
      // {
      //   path: 'Terms/:termsType',
      //   name: 'Auth.Terms',
      //   meta: {
      //     preventAuth: false,
      //     /*header: {
      //       title: 'common.service.terms',
      //       left: true,
      //     },*/
      //   },
      //   component: () => import('@customer/views/auth/Terms.vue'),
      //   props: route => ({
      //     termsType: route.params.termsType,
      //   }),
      // }
    ],
  },
  {
    path: '/Shops',
    component: DefaultLayout,
    redirect: '/Shops/List',
    hidden: true,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'List',
        name: 'Shop.List',
        meta: {
          header: {
            area: true,
            searchBtn: true,
            myBtn: true,
            titleLeft: true,
          },
          footer: true,
          footerMain: 'shop',
        },
        component: () => import('@/front/customer/views/shops/List.vue'),
      },
      {
        path: 'List/:id',
        name: 'Shops.Detail',
        meta: {
          header: {
            title: ' ',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/shops/detail/Detail.vue'),
        props: route => ({
          bottomBtn: route.params.bottomBtn,
        }),
      },
      {
        path: 'List/location',
        name: 'Shops.location',
        meta: {
          header: {
            title: '',
            left: true,
          },
        },
        component: () => import('@/common/components/shop/ShopLocation.vue'),
      },
      {
        path: 'reviews/:id',
        name: 'Shops.Reviews',
        meta: {
          header: {
            // title: route => route.params.title,
            title: ' ',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/shops/detail/MoreReviews.vue'),
      },
      {
        path: 'ListSend',
        name: 'Shops.listsend',
        component: () => import('@/front/customer/views/shops/ListSend.vue'),
        props: route => ({
          estimateId: route.query.estimateId,
          estimateManage: route.query.estimateManage,
          // uuid: route.query.uuid,
        }),
      },
      {
        path: 'Search',
        name: 'Shops.search',
        component: () => import('@/front/customer/views/shops/Search.vue'),
        props: route => ({
          searchText: route.query.searchText,
        }),
      },
      {
        path: 'priorConsent',
        name: 'Shops.priorConsent',
        meta: {
          header: {
            title: '사전승낙서',
            left: true,
          },
        },
        component: () => import('@/common/components/shop/PriorConsent.vue'),
        props: route => ({
          id: route.query.id,
        }),
      },
      // {
      //   path: 'Terms/:termsType',
      //   name: 'Auth.Terms',
      //   meta: {
      //     preventAuth: false,
      //     /*header: {
      //       title: 'common.service.terms',
      //       left: true,
      //     },*/
      //   },
      //   component: () => import('@customer/views/auth/Terms.vue'),
      //   props: route => ({
      //     termsType: route.params.termsType,
      //   }),
      // }{
      {
        path: 'WriteReview/:id',
        name: 'Shops.WriteReview',
        meta: {
          header: {
            title: '리뷰 작성하기',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/shops/detail/WriteReview.vue'),
      },
    ],
  },
  {
    path: '/Chat',
    component: DefaultLayout,
    redirect: '/Chat/List',
    meta: {
      requiresAuth: false,
    },
    children: [
      {
        path: 'List',
        name: 'chat.list',
        meta: {
          header: {
            title: '상담 내역',
            titleLeft: true,
            searchBtn: true,
            myBtn: true,
          },
          footer: true,
          footerMain: 'chat',
        },
        component: () => import('@/front/customer/views/chat/List.vue'),
      },
      {
        path: 'Room/:uuid',
        name: 'chat.room',
        meta: {
          header: {
            title: ' ',
            left: true,
            // right: true,
            leave: true,
            like: true,
          },
        },
        component: () => import('@common/components/chat/Room.vue'),
        props: route => ({
          uuid: route.params.uuid,
        }),
      },
      {
        path: 'Room/create/:storeId',
        name: 'chat.room.create',
        meta: {
          header: {
            title: ' ',
            left: true,
            // right: true,
            leave: true,
            like: true,
          },
        },
        component: () => import('@common/components/chat/Room.vue'),
        props: route => ({
          storeId: route.params.storeId,
        }),
      },
      {
        path: 'ChatReport',
        name: 'chat.report',
        meta: {
          header: {
            title: '신고하기',
            left: true,
          },
        },
        component: () => import('@common/components/chat/ChatReport.vue'),
      },
    ],
  },
  {
    path: '/Agreement',
    component: DefaultLayout,
    redirect: '/Agreement/Terms',
    hidden: true,
    meta: {},
    children: [
      {
        path: 'Terms',
        name: 'Agreement.Terms',
        meta: {},
        component: () =>
          import('@/front/customer/components/common/Agreements.vue'),
        props: route => ({
          type: route.params.type,
          header: route.params.title,
        }),
      },
    ],
  },
  {
    path: '/Manual',
    component: DefaultLayout,
    redirect: '/Manual/Main',
    hidden: true,
    meta: {},
    children: [
      {
        path: 'Main',
        name: 'Manual.Main',
        meta: {
          header: {
            title: '퍼스 사용 설명서',
            left: true,
          },
        },
        component: () => import('@/front/customer/views/manual/Main.vue'),
        props: route => ({
          storeId: route.params.isTab,
        }),
      },
    ],
  },
  {
    path: '/Counseling',
    component: DefaultLayout,
    redirect: '/Counseling/List',
    hidden: true,
    meta: {},
    children: [
      {
        path: 'List',
        name: 'Counseling.List',
        meta: {
          header: {
            title: '상담 시작하기',
            left: true,
          },
        },
        component: () => import('@/front/customer/views/counseling/List.vue'),
      },
    ],
  },
  {
    path: '/InternetCommerce',
    component: DefaultLayout,
    redirect: '/InternetCommerce/Create',
    hidden: true,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'Main',
        name: 'InternetCommerce.Main',
        meta: {
          header: {
            titleInternetImg: true,
            title: '인터넷/TV',
            left: true,
            searchBtn: true,
            myBtn: true,
            bgGr: true,
          },
          footer: true,
          footerMain: 'main',
        },
        component: () =>
          import('@/front/customer/views/internetCommerce/Main.vue'),
      },
      {
        path: 'Create',
        name: 'InternetCommerce.Create',
        meta: {
          header: {
            title: '인터넷 견적 받아보기',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/internetCommerce/Create.vue'),
      },
      {
        path: 'RequestForm',
        name: 'InternetCommerce.RequestForm',
        meta: {
          header: {
            title: '인터넷 견적 받아보기',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/internetCommerce/RequestForm.vue'),
      },
      {
        path: 'List',
        name: 'InternetCommerce.List',
        meta: {
          footer: true,
          footerMain: 'estimate',
          header: {
            title: '견적수신함',
            titleLeft: true,
            info_1: true,
            searchBtn: true,
            myBtn: true,
            listType: 'internet',
          },
        },
        component: () =>
          import('@/front/customer/views/internetCommerce/List.vue'),
      },
      {
        path: 'Detail',
        name: 'InternetCommerce.Detail',
        meta: {
          header: {
            title: route =>
              route.query.status == 'ING'
                ? '진행 중인 견적 요청'
                : '마감 된 견적 요청',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/internetCommerce/Detail.vue'),
        props: route => ({
          id: route.query.id,
          status: route.query.status,
        }),
      },
      {
        path: 'Skylife',
        name: 'InternetCommerce.Skylife',
        meta: {
          header: {
            title: '인터넷 견적 받아보기',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/internetCommerce/CreateSkylife.vue'),
      },
      {
        path: 'ItemView',
        name: 'InternetCommerce.ItemView',
        meta: {
          header: {
            title: '요금제 상세',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/internetCommerce/ItemView.vue'),
      },
      {
        path: 'ProductList',
        name: 'InternetCommerce.ProductList',
        meta: {
          header: {
            title: '내 또래 BEST 상품',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/internetCommerce/ProductList.vue'),
      },
      {
        path: 'GuaranteeApplyList',
        name: 'InternetCommerce.GuaranteeApplyList',
        meta: {
          header: {
            title: ' ',
            closeBtn: true,
            closeLinkName: 'Apply.Main',
          },
        },
        component: () =>
          import(
            '@/front/customer/views/internetCommerce/GuaranteeApplyList.vue'
          ),
      },
      {
        path: 'GuaranteeConfirm',
        name: 'InternetCommerce.GuaranteeConfirm',
        meta: {
          header: {
            title: ' ',
            closeBtn: true,
            closeLinkName: 'Apply.Main',
          },
        },
        component: () =>
          import(
            '@/front/customer/views/internetCommerce/GuaranteeConfirm.vue'
          ),
      },
    ],
  },
  {
    path: '/Apply',
    component: DefaultLayout,
    redirect: '/Apply/Main',
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'Main',
        name: 'Apply.Main',
        meta: {
          header: {
            title: '신청현황',
            titleLeft: true,
            searchBtn: true,
            myBtn: true,
          },
          footer: true,
          footerMain: 'apply',
        },
        component: () =>
          import('@/front/customer/views/internetApply/Main.vue'),
      },
      {
        path: 'ApplyForm',
        name: 'InternetCommerce.ApplyForm',
        meta: {
          header: {
            title: ' ',
            left: true,
          },
        },
        component: () =>
          import('@common/components/internetCommerce/ApplyForm.vue'),
      },
      {
        path: 'ApplyDetail',
        name: 'InternetCommerce.ApplyDetail',
        meta: {
          header: {
            title: route => route.params.title || '인터넷 가입 신청서',
            left: true,
          },
        },
        component: () =>
          import('@common/components/internetCommerce/ApplyDetail.vue'),
      },
      {
        path: 'PromotionDetailKt',
        name: 'InternetCommerce.PromotionDetailKt',
        meta: {
          header: {
            title: ' ',
            left: true,
          },
        },
        component: () =>
          import(
            '@/front/customer/views/internetCommerce/PromotionDetailKt.vue'
          ),
      },
      {
        path: 'PromotionDetailHello',
        name: 'InternetCommerce.PromotionDetailHello',
        meta: {
          header: {
            title: 'LG 헬로비전 프로모션',
            left: true,
          },
        },
        component: () =>
          import(
            '@/front/customer/views/internetCommerce/PromotionDetailHello.vue'
          ),
      },
    ],
  },
  {
    path: '/InternetDirect',
    component: DefaultLayout,
    redirect: '/InternetDirect/Main',
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'Main',
        name: 'InternetDirect.Main',
        meta: {
          header: {
            title: '인터넷 다이렉트 가입',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/internetDirect/Main.vue'),
      },
    ],
  },
  {
    path: '/Mobile',
    component: DefaultLayout,
    redirect: '/Mobile/Main',
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'Main',
        name: 'Mobile.Main',
        meta: {
          header: {
            titleMobileImg: true,
            title: '휴대폰',
            left: true,
            searchBtn: true,
            myBtn: true,
            bgGr: true,
          },
          footer: true,
          footerMain: 'main',
        },
        component: () => import('@/front/customer/views/mobile/Main.vue'),
      },
      {
        path: 'Create',
        name: 'Mobile.Create',
        meta: {
          header: {
            title: '휴대폰 견적 받아보기',
            left: true,
          },
        },
        component: () => import('@/front/customer/views/mobile/Create.vue'),
      },
      {
        path: 'RequestForm',
        name: 'Mobile.RequestForm',
        meta: {
          header: {
            title: '휴대폰 견적 받아보기',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/mobile/RequestForm.vue'),
      },
      {
        path: 'List',
        name: 'Mobile.List',
        meta: {
          footer: true,
          footerMain: 'estimate',
          header: {
            title: '견적수신함',
            titleLeft: true,
            info_1: true,
            searchBtn: true,
            myBtn: true,
            listType: 'mobile',
          },
        },
        component: () => import('@/front/customer/views/mobile/List.vue'),
      },
      {
        path: 'View',
        name: 'Mobile.View',
        meta: {
          header: {
            title: route =>
              route.query.status == 'ING'
                ? '진행 중인 견적 요청'
                : '마감 된 견적 요청',
            left: true,
          },
        },
        component: () => import('@/front/customer/views/mobile/View.vue'),
        props: route => ({
          id: route.query.id,
        }),
      },
      // {
      //   path: 'Detail',
      //   name: 'Mobile.Detail',
      //   meta: {
      //     header: {
      //       title: '받은 견적 상세',
      //       left: true,
      //     },
      //   },
      //   component: () => import('@/front/customer/views/mobile/Detail.vue'),
      //   props: route => ({
      //     requestId: route.query.requestId,
      //     payType: route.query.payType,
      //     orderType: route.query.orderType,
      //   }),
      // },
      {
        path: 'Payment',
        name: 'Mobile.PaymentModify',
        meta: {
          header: {
            title: '요금제 선택하기',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/mobile/PaymentModify.vue'),
        props: route => ({
          requestId: route.params.requestId,
          payType: route.params.payType,
          orderType: route.params.orderType,
        }),
      },
      {
        path: 'Promise',
        name: 'Mobile.Promise',
        meta: {
          header: {
            title: '방문약속',
            left: true,
          },
        },
        component: () => import('@/common/components/mobile/Promise.vue'),
        props: route => ({
          promiseId: route.query.promiseId,
          storeId: route.query.storeId,
          chatRoomId: route.query.chatRoomId,
          chatRoomUuid: route.query.chatRoomUuid,
        }),
      },
      {
        path: 'EstimateDetail',
        name: 'Mobile.EstimateDetail',
        meta: {
          header: {
            title: '상세 보기',
            left: true,
          },
        },
        component: () => import('@common/components/mobile/EstimateDetail.vue'),
        props: route => ({
          requestId: route.query.requestId,
          estimateId: route.query.estimateId,
          // callPart: route.query.callPart,
        }),
      },
      {
        path: 'PromiseList',
        name: 'Mobile.PromiseList',
        meta: {
          header: {
            title: '신청현황',
            titleLeft: true,
            searchBtn: true,
            myBtn: true,
          },
          footer: true,
          footerMain: 'apply',
        },
        component: () =>
          import('@/front/customer/views/mobile/PromiseList.vue'),
      },
      {
        path: 'ApplyList',
        name: 'Mobile.ApplyList',
        meta: {
          header: {
            title: '신청현황',
            titleLeft: true,
            searchBtn: true,
            myBtn: true,
          },
          footer: true,
          footerMain: 'apply',
        },
        component: () => import('@/front/customer/views/mobile/ApplyList.vue'),
      },
      {
        path: 'ItemView',
        name: 'Mobile.ItemView',
        meta: {
          header: {
            title: '휴대폰 상세',
            left: true,
          },
        },
        component: () => import('@/front/customer/views/mobile/ItemView.vue'),
      },
      {
        path: 'ApplyForm',
        name: 'Mobile.ApplyForm',
        meta: {
          header: {
            title: route => route.params.title || '휴대폰 개통신청서',
            left: true,
          },
        },
        component: () => import('@/front/customer/views/mobile/ApplyForm.vue'),
      },
      {
        path: 'ApplyDetail',
        name: 'Mobile.ApplyDetail',
        meta: {
          header: {
            title: route => route.params.title || '휴대폰 개통신청서',
            left: true,
          },
        },
        component: () => import('@/common/components/mobile/ApplyDetail.vue'),
      },
      // {
      //   path: 'DealList',
      //   name: 'Mobile.DealList',
      //   meta: {
      //     header: {
      //       title: ' ',
      //       leftMain: true,
      //       bgGr: true,
      //     },
      //   },
      //   component: () => import('@/front/customer/views/mobile/DealList.vue'),
      // },
      // {
      //   path: 'DealDetail',
      //   name: 'Mobile.DealDetail',
      //   meta: {
      //     header: {
      //       title: '상품 상세',
      //       left: true,
      //     },
      //   },
      //   component: () => import('@/front/customer/views/mobile/DealDetail.vue'),
      // },
      // {
      //   path: 'DeviceInfo',
      //   name: 'Mobile.DeviceInfo',
      //   meta: {
      //     header: {
      //       title: '휴대폰 스팩 보기',
      //       left: true,
      //     },
      //   },
      //   component: () => import('@/front/customer/views/mobile/DeviceInfo.vue'),
      // },
    ],
  },
  {
    path: '/Community',
    component: DefaultLayout,
    redirect: '/Community/Main',
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'Main',
        name: 'Community.Main',
        meta: {
          footer: true,
          footerMain: 'community',
        },
        component: () => import('@/front/customer/views/community/Main.vue'),
      },
      {
        path: 'Knowhow/List',
        name: 'Knowhow.List',
        meta: {
          header: {
            title: '퍼뮤니티',
            left: true,
            knowhowMy: true,
          },
        },
        component: () =>
          import('@/front/customer/views/community/knowhow/List.vue'),
      },
      {
        path: 'Knowhow/Mine',
        name: 'Knowhow.Mine',
        meta: {
          header: {
            title: '내 작성 글',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/community/knowhow/Mine.vue'),
      },
      {
        path: 'Knowhow/Detail/:id',
        name: 'Knowhow.Detail',
        meta: {
          header: {
            title: '퍼뮤니티',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/community/knowhow/Detail.vue'),
      },
      {
        path: 'Knowhow/Write',
        name: 'Knowhow.Write',
        meta: {
          header: {
            title: '질문하기',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/community/knowhow/Write.vue'),
      },
      {
        path: 'Board/List',
        name: 'Board.List',
        meta: {
          header: {
            title: '자유게시판',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/community/board/List.vue'),
      },
      {
        path: 'Board/Mine',
        name: 'Board.Mine',
        meta: {
          header: {
            title: '자유게시판 내 작성 글',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/community/board/Mine.vue'),
      },
      {
        path: 'Board/Detail/:id',
        name: 'Board.Detail',
        meta: {
          header: {
            title: '자유게시판',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/community/board/Detail.vue'),
      },
      {
        path: 'Board/Write',
        name: 'Board.Write',
        meta: {
          header: {
            title: '글쓰기',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/community/board/Write.vue'),
      },
    ],
  },
  {
    path: '/search',
    component: DefaultLayout,
    redirect: '/search',
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '/search',
        name: 'Search',
        meta: {
          header: {
            title: '검색',
            left: true,
          },
        },
        component: () => import('@/front/customer/views/search/Index.vue'),
      },
      {
        path: 'reviews',
        name: 'Search.Reviews',
        meta: {
          header: {
            title: '리뷰 검색 결과',
            left: true,
          },
        },
        component: () =>
          import('@/front/customer/views/shops/detail/MoreReviews.vue'),
      },
    ],
  },
];
